module.exports = __webpack_public_path__ + "img/Helmet Icon - charcoal.2ec8d59c.svg";